module.exports = __webpack_public_path__ + "media/images/proof_links/hulu-e274d4e29dd39ae17d158d127d8c9626.svg";